<template>
  <div>
    <div class="ui top attached segment" style="text-align: center">
      <h2 class="m-text-500">小伙伴们</h2>
    </div>
    <div class="ui attached segment">
      <div class="ui link three doubling cards">
        <a
          :href="item.website"
          target="_blank"
          rel="external nofollow noopener"
          class="card"
          :style="randomRGB()"
          v-for="(item, index) in friendList"
          :key="index"
          @click="addViews(item.nickname)"
        >
          <div class="image">
            <img :src="item.avatar" onerror="this.src = '/img/error.png'" />
          </div>
          <div class="content">
            <div class="header">{{ item.nickname }}</div>
            <div class="description">{{ item.description }}</div>
          </div>
        </a>
      </div>
    </div>
    <!--页面描述-->
    <div class="ui teal attached segment">
      <div class="typo content" v-viewer v-html="info.content"></div>
    </div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <div slot="header">
        <span>申请友链</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="12" :offset="0">
          <el-form
            :model="applyForm"
            ref="applyForm"
            :rules="applyFormRules"
            label-width="100px"
            :inline="false"
            size="mini"
          >
            <el-form-item label="网站地址：" prop="website">
              <el-input v-model="applyForm.website"></el-input>
            </el-form-item>
            <el-form-item label="网站名称：" prop="nickname">
              <el-input v-model="applyForm.nickname"></el-input>
            </el-form-item>
            <el-form-item label="网站描述：" prop="description">
              <el-input v-model="applyForm.description"></el-input>
            </el-form-item>
            <el-form-item label="网站图标：" prop="avatar">
              <el-input v-model="applyForm.avatar"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                :loading="btnLoading"
                :disabled="btnDisabled"
                type="primary"
                @click="handleApply"
                >申请</el-button
              >
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12" :offset="0"></el-col>
      </el-row>
    </el-card>

    <!--评论-->
    <div class="ui bottom teal attached segment threaded comments">
      <CommentList :page="2" :blogId="null" v-if="info.commentEnabled" />
      <h3 class="ui header" v-else>评论已关闭</h3>
    </div>
  </div>
</template>

<script>
import { getData, addViewsByNickname, applyFriend } from "@/api/friend";
import CommentList from "@/components/comment/CommentList";

export default {
  name: "Friends",
  components: { CommentList },
  data() {
    return {
      btnDisabled: false,
      btnLoading: false,
      friendList: [],
      bgColor: [
        "#1abc9c",
        "#2ecc71",
        "#3498db",
        "#9b59b6",
        "#34495e",
        "#f1c40f",
        "#e67e22",
        "#e74c3c",
        "#ee5a24",
        "#9980fa",
        "#8c7ae6",
        "#f79f1f",
      ],
      info: {
        content: "",
        commentEnabled: false,
      },
      applyForm: {
        nickname: undefined,
        description: undefined,
        website: undefined,
        avatar: undefined,
      },
      applyFormRules: {
        nickname: [
          { required: true, message: "请输入网站名称", trigger: "blur" },
        ],
        description: [
          { required: true, message: "请输入网站描述", trigger: "blur" },
        ],
        website: [
          { required: true, message: "请输入网站地址", trigger: "blur" },
        ],
        avatar: [
          { required: true, message: "请输入网站图标", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      getData()
        .then((res) => {
          if (res.code === 200) {
            this.friendList = res.data.friendList;
            this.info = res.data.friendInfo;
          } else {
            this.msgError(res.msg);
          }
        })
        .catch((e) => {
          this.msgError("请求失败" + e);
        });
    },
    handleApply() {
      this.$refs["applyForm"].validate((valid) => {
        if (valid) {
          this.btnDisabled = true;
          this.btnLoading = true;
          applyFriend(this.applyForm)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success("申请成功");
                this.$refs["applyForm"].resetFields();
              } else {
                this.$message.warning(res.msg);
              }
            })
            .catch((e) => {
              this.$message.danger("申请成功" + e);
            })
            .finally(() => {
              this.btnDisabled = false;
              this.btnLoading = false;
            });
        }
      });
    },
    addViews(nickname) {
      addViewsByNickname(nickname);
    },
    randomRGB() {
      const index = Math.floor(Math.random() * this.bgColor.length);
      return { backgroundColor: this.bgColor[index] };
    },
  },
};
</script>

<style scoped>
.card .image {
  width: 70px !important;
  margin: 10px auto 0px;
  background: unset !important;
}

.card .image img {
  border-radius: 100% !important;
  width: 70px !important;
  height: 70px !important;
}

.card .content {
  text-align: center;
  padding: 10px 14px !important;
  border-top: 0 !important;
}

.card .content * {
  color: #fff !important;
}

.card .content .header {
  font-size: 16px !important;
}

.card .content .description {
  font-size: 12px !important;
}

.card .content .description {
  margin-top: 5px !important;
  margin-bottom: 7px;
}
</style>